import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  getCMSFailure,
  getCMSSuccess,
  updateCMSFailure,
  updateCMSSuccess,
  showCMSSuccess,
  showCMSFailure
} from "../../actions";
import { GET_CMS, UPDATE_CMS, SHOW_CMS } from "../../Actions/types";
import api from "../../../helper/api";

function* fetchCMS(action) {
  try {
    const response = yield api.get("admin/cms/cms-list");
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response.data?.data);
      yield put(getCMSSuccess({ getData: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(getCMSFailure({ getError: e }));
  }
}


function* fetchCMSUpdate(action) {
  try {
    const response = yield api.put(`/admin/cms/edit-cms/${action?.payload?.form?.id}`, action?.payload?.form);
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response.data?.data);
      yield put(updateCMSSuccess({ updateData: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(updateCMSFailure({ updateError: e }));
  }
}

function* fetchCMSShow(action) {
  try {
    const response = yield api.get(`/admin/cms/view-cms/${action?.payload?.form?.id}`, 
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response.data?.data);
      yield put(showCMSSuccess({ showData: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(showCMSFailure({ showError: e }));
  }
}

function* cmsWatcher() {
  yield takeLatest(GET_CMS, fetchCMS);
}

function* cmsUpdateWatcher() {
  yield takeLatest(UPDATE_CMS, fetchCMSUpdate);
}
function* cmsShowWatcher() {
  yield takeLatest(SHOW_CMS, fetchCMSShow);
}

export default function* cmsSaga() {
  yield all([cmsWatcher(), cmsUpdateWatcher(), cmsShowWatcher()]);
}
